export default __webpack_public_path__ + "static/media/Training.77e5f364.png";